var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './ModalGPT.module.scss';
import { GPTIconForTable } from '../../helpers/icons';
import { getAssistanceByData } from "../../Redux/_actions/asyncActions/Trainer/get_assistance_by_data";
import { Button } from "antd";
import { useTypeDispatch } from "../../hooks/useTypeHooks";
var ChatHeader = function (_a) {
    var setLike = _a.setLike, setParagraphs = _a.setParagraphs, handDataGPT = _a.handDataGPT, isLoadingAI = _a.isLoadingAI;
    var dispatch = useTypeDispatch();
    var trace = handDataGPT === null || handDataGPT === void 0 ? void 0 : handDataGPT.result.trace;
    var players = handDataGPT === null || handDataGPT === void 0 ? void 0 : handDataGPT.positions;
    var hands = handDataGPT === null || handDataGPT === void 0 ? void 0 : handDataGPT.hands;
    var spotId = handDataGPT === null || handDataGPT === void 0 ? void 0 : handDataGPT.spotId;
    var stacks = handDataGPT === null || handDataGPT === void 0 ? void 0 : handDataGPT.stacks;
    var isHero = handDataGPT === null || handDataGPT === void 0 ? void 0 : handDataGPT.isHero;
    return (_jsxs("div", __assign({ className: styles.sharkWrapper }, { children: [_jsxs("div", __assign({ className: styles.AIHeaderWrapper }, { children: [_jsx("div", { className: styles.sharkAI }), _jsxs("div", __assign({ className: styles.sharkGPT }, { children: [_jsx("span", { children: "Your personal poker coach" }), _jsxs("div", __assign({ className: styles.GPTLogoWrapper }, { children: [_jsx(GPTIconForTable, {}), "Based on GPT"] }))] }))] })), _jsx("div", __assign({ className: styles.rateWrapper }, { children: _jsx(Button, __assign({ type: 'default', disabled: isLoadingAI, onClick: function () {
                        setLike(null);
                        setParagraphs([{ isFirstAIMessage: true, isUserMessage: false, message: 'Something went wrong' }]);
                        dispatch(getAssistanceByData(spotId, players, isHero, stacks, hands, trace, true));
                    } }, { children: "New explanation" })) }))] })));
};
export default ChatHeader;
